module.exports = __webpack_public_path__ + "img/icon-person.e1b8fd75.png";